import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import {
  CHEQUE,
  data as paymentMethods,
  ESP,
} from '@lba-dev/package.local-globals/paymentMethods';
import {
  data as lateReasons
} from '@lba-dev/package.local-globals/lateReasons';

import Selector from '../../Utils/Selector';
import MoneyInput from '../../CustomInputs/MoneyInput';
import CustomSwitch from '../../CustomInputs/CustomSwitch';
import CustomTextField from '../../CustomInputs/CustomTextField';
import CustomRadioGroup from '../../CustomInputs/CustomRadioGroup';
import Attachments from '../../Utils/Attachments';
import DatePicker from '../../DatePicker';
import { getTime } from '../../../utils/date';
import TimePicker from '../../TimePicker';
import repairTypes from '../../../constants/repairTypes';

const paymentMethodsSelect = paymentMethods.map((e) => (
  <MenuItem
    key={e._id}
    value={e._id}
    children={e.fullName}
    disabled={['Facture à envoyer', 'Virement', 'Aucun'].includes(e.fullName)}
  />
));

const lateReasonsSelect = lateReasons.slice(2, 4).map((e) => (
  <MenuItem key={e._id} value={e._id} children={e.name} />
));

const Content = ({
  showOnlyPrice,
  applyTva,
  price,
  paymentChoice,
  additionnalInfos,
  setPrice,
  toggleTva,
  setPaymentChoice,
  setAdditionnalInfos,
  attachments,
  addFile,
  productsSum,
  deleteFile,
  lateReason,
  setLateReason,
  dateIntervention,
  setDateIntervention,
  repairType,
  setRepairType,
  isNotSameDate,
  fromProposition = false
}) => {
  const [
    displayInterventionQuestion,
    setDisplayInterventionQuestion
  ] = useState('0');
  const [hoursMinutes, setHoursMinutes] = useState('');

  const changeHour = (value) => {
    setHoursMinutes(value);
  };

  useEffect(() => {
    if (hoursMinutes) {
      const [hour, minutes] = hoursMinutes.split(':');
      const date = new Date(dateIntervention);

      date.setHours(
        Number.parseInt(hour, 10),
        Number.parseInt(minutes, 10),
        0,
        0
      );
      setDateIntervention(date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hoursMinutes])

  const setDateInterventionWithHours = (date) => {

    const newDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      dateIntervention.getHours(),
      dateIntervention.getMinutes()
    );
    setDateIntervention(newDate);
  }

  return (
    <>
      {!fromProposition && (
        <>
          {!showOnlyPrice && (
            <React.Fragment>
              <Grid item xs={12}>
                <Typography children="Quel est le mode de règlement ?" />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Selector
                  title={
                    paymentChoice === ESP
                      ? 'Un signalement sera émis'
                      : 'Mode de règlement'
                  }
                  error={paymentChoice === ESP}
                  value={paymentChoice}
                  handleChange={setPaymentChoice}
                  children={paymentMethodsSelect}
                />
              </Grid>
            </React.Fragment>
          )}
          <Grid item xs={12}>
            <Typography
              children={`Quel est le montant final${
                !showOnlyPrice && [ESP, CHEQUE].includes(paymentChoice)
                  ? ' récupéré '
                  : ' de l\'intervention'
              }? `}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MoneyInput
              disabled={productsSum && price === productsSum}
              error={!price || (productsSum && productsSum !== price)}
              label="Montant final"
              defaultValue={price}
              setData={(p, v) => setPrice(v)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomSwitch
              disabled={productsSum && price === productsSum}
              label={applyTva ? 'TTC' : 'HT'}
              value={applyTva}
              setData={toggleTva}
            />
          </Grid>
        </>
      )}
      <>
        <Grid item xs={12}>
          <Typography
            children={'Est-ce que la date et heure ont été respectées ?'}
          />
        </Grid>
        <CustomRadioGroup
          grid
          xs={10}
          sm={10}
          values={[
            { label: 'Oui', value: '0' },
            { label: 'Non', value: '1' },
          ]}
          value={displayInterventionQuestion.toString()}
          setData={(p, v) => setDisplayInterventionQuestion(+v)}
        />
        {displayInterventionQuestion === 1 && (
          <>
            <Grid item xs={4} sm={4}>
              <DatePicker
                before={true}
                label={'Date d\'intervention'}
                startDate={dateIntervention}
                onChange={(v) => setDateInterventionWithHours(v.toDate())}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <TimePicker
                label="Heure d'arrivée"
                value={getTime(new Date(dateIntervention))}
                onChange={(e) => changeHour(e.target.value)}
                size="100%"
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <Selector
                title={'Motif'}
                value={lateReason}
                handleChange={setLateReason}
                children={lateReasonsSelect}
              />
            </Grid>
          </>
        )}
      </>
      {!fromProposition && isNotSameDate ? (
        <>
          <Grid item xs={12}>
            <Typography children={'Confirmez-vous la date d\'intervention ?'} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              before={true}
              label={'Date d\'intervention'}
              startDate={dateIntervention}
              onChange={(v) => setDateInterventionWithHours(v.toDate())}
            />
          </Grid>
        </>
      ) : (
        ''
      )}
      <CustomRadioGroup
        grid
        xs={12}
        sm={6}
        md={12}
        label="Etat de la réparation"
        value={repairType.toString()}
        values={repairTypes.data}
        setData={(p, v) => setRepairType(Number(v))}
      />
      <Grid item xs={12}>
        <CustomTextField
          customTimeOut={0}
          label="Renseignements complémentaires"
          rows={5}
          texttransform=" "
          placeholder={`- La raison de la panne ou fuite
      - La solution a apporter au client
      - Si devis complémentaire à faire`}
          value={additionnalInfos}
          setData={(p, v) => setAdditionnalInfos(v)}
        />
      </Grid>
      {!fromProposition && (
        <Attachments data={attachments} onAdd={addFile} onDelete={deleteFile} />
      )}
    </>
  );
}

export default Content;
